export const API_URL = process.env.REACT_APP_API_URL
export const POLY_EXPLORER_URL = process.env.REACT_APP_EXPLORER_URL
export const PLOYGON_AMOY_RPC_URL = process.env.REACT_APP_PLOYGON_AMOY_RPC_URL
export const CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS
export const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID)
export const StripPublicKey = String(process.env.REACT_APP_API_STRIPE_PAYEMENT)
